// extracted by mini-css-extract-plugin
export default {"heading4":"heading4--e0RHy"};